import React from "react";
import trash_svg from '../../assets/garbage-icon.svg';

const QuantityCell = ({ currentQuantity, row, showTrash, showAddtoRequest, onAddToRequest, onRemoveFromRequest, onChange }) => {
    return (
        <>
            {showTrash &&
                <button
                    className="trash-button"
                    onClick={() => onRemoveFromRequest(row.original.id)}>
                    <img alt="Trash icon toggle for removing item from request" src={trash_svg} />
                </button>
            }
            <input type="number" value={currentQuantity} onChange={(e) => onChange(row.original.id, e.target.value)} name={`tooling-quanity`} step="1" min="0" max="9999" />
            {showAddtoRequest &&
                <button
                    onClick={() => { onAddToRequest(row.original, currentQuantity) }}
                    className={currentQuantity === 0 ? "disabled" : ""}>Add <span>to Request</span>
                </button>
            }
        </>

    )
}


export default QuantityCell;